import React from 'react'

import WebhookPixPagamentoFormPageContainer from './WebhookPixPagamentoFormPageContainer'

export class WebhookPixPagamentoFormPage extends React.Component {
  render() {
    return <WebhookPixPagamentoFormPageContainer {...this.props} />
  }
}
